import React, { createContext, useState } from 'react';

export const ConfigContext = createContext();

export const ConfigProvider = ({ children }) => {
  // const [apiURL] = useState('http://192.168.5.122:3191/');
  // const [apiURL] = useState('http://143.110.190.50:3191/');
  // const [apiURL] = useState('http://143.110.190.50:4002/');
  const [apiURL] = useState('https://masterapi.abstarthr.in/');
  // const [apiURL] = useState('http://localhost:3191/');
  // set globley
  const [token, setToken] = useState(localStorage.getItem("token_master"));
  const [company_id] = useState(localStorage.getItem("company_id_master"));
  const [userId,setUserId] = useState(localStorage.getItem("user_id_master"));

  const [apiHeaderJson, setHeaderJSON] = useState({
    'Content-Type': "application/json", 
    token: `${token}`, 
    "x-company-id": company_id, 
    "x-user-id": userId,
  })
  const [apiHeaderFile, setHeaderFile] = useState({ 
    token: `${token}`, 
    "Content-Type": "multipart/form-data", 
    "x-company-id": company_id, 
    "x-user-id": userId,
  })


  const handleUpdateLogin = (data) => {
    setToken(data?.token);
    setUserId(data?.user_id)
    localStorage.setItem('token_master', data?.token);
    localStorage.setItem('user_id_master', data?.user_id);
    
  }

  var vals = {
    apiURL,
    token,
    apiHeaderJson,
    apiHeaderFile,
    handleUpdateLogin,
  };
  return (
    <ConfigContext.Provider value={vals}>
      {children}
    </ConfigContext.Provider>
  );
};
